import { render } from "./TicketItem.vue?vue&type=template&id=4c88d08b"
import script from "./TicketItem.vue?vue&type=script&lang=js"
export * from "./TicketItem.vue?vue&type=script&lang=js"

import "./TicketItem.vue?vue&type=style&index=0&id=4c88d08b&lang=css"

import exportComponent from "/home/runner/work/fpv-raffle/fpv-raffle/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__